import React from 'react'
import styled from 'styled-components'
import { useUpdateCheck } from '../../lib/customHooks'
const MessageContainer = styled.div`
  visibility: ${({ show }) => show ? 'visible' : 'hidden'};
  min-width: 250px;
  background-color: #333;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.8;
  text-align: center;
  border-radius: 4px;
  padding: 16px;
  position: fixed;
  z-index: 9999999;
  right: 16px;
  bottom: 30px;
  animation: fadein 1s;
  @keyframes fadein {
    from {bottom: 0; opacity: 0;}
    to {bottom: 30px; opacity: 1;}
  }
  @keyframes fadeout {
    from {bottom: 30px; opacity: 1;}
    to {bottom: 0; opacity: 0;}
  }

  a {
    text-decoration: underline;
    color: unset;
  }
  @media (max-width: 768px) {
    right: 8px;
    left: 8px;
  }
`
const CrossButton = styled.div`
  position: absolute;
  top: 4px;
  right: 8px;
  cursor: pointer;
`
const Toast = ({show, onClose, renderMessage=() => null}) => (
    <MessageContainer show={show}>
      {renderMessage()}
      {onClose && <CrossButton onClick={onClose}>X</CrossButton>}
    </MessageContainer>
)

export const UpdateNoticeToast = props => {
  const { status, reloadPage } = useUpdateCheck({
    type: 'interval',
    interval: 300000,
  });
  if (status !== 'available') return null
  return (
    <Toast
      {...props}
      show
      renderMessage={() => (
        <>We have a new update! click <a onClick={reloadPage}>here</a> to refresh</>
      )}
    />
  )
}

export default Toast
